export enum Languages {
    EN = 'en',
    ZH = 'zh-Hans',
    JA = 'ja'
}
